import React from "react";
import { Container } from "./styles/bottomhighlight";

export default function BottomHighlightLine({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}